export default __webpack_public_path__ + "static/arrived-c8abf42f6eb0a9f5c803ab36c8af66b8.svg";